import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// NOTE: hreflang and canonical tags are pre-rendered into each route's
// index.html by scripts/prerender-meta.mjs at build time. Do NOT inject them
// from JS here — that caused duplicate hreflang entries in Ahrefs reports
// (e.g. "More than one page is linked for the same language").
// PageMeta.tsx still updates canonical/og:url for SPA navigations between
// routes after the initial load, but the initial DOM already has correct tags.

function installDomMutationGuard() {
  if (typeof Node === "undefined") return;

  const guardedPrototype = Node.prototype as Node & {
    __dutchDryIceDomMutationGuard?: boolean;
  };

  if (guardedPrototype.__dutchDryIceDomMutationGuard) return;

  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  Object.defineProperty(guardedPrototype, "__dutchDryIceDomMutationGuard", {
    value: true,
    configurable: false,
  });

  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      return child;
    }

    return originalRemoveChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }

    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}

installDomMutationGuard();

createRoot(document.getElementById("root")!).render(<App />);
